import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";

let cancelToken;

const getClassVisualReport = () => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.REPORT.GRAPHICAL_REPORT.GET_CLASS_VISUAL_REPORT,
    cancelToken
  );
};

export default getClassVisualReport;
